// extracted by mini-css-extract-plugin
module.exports = {"loader":"loadable_loader__XE4KH","spin":"loadable_spin__cIxwV"};